import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createMetaManager, plugin as metaPlugin } from "vue-meta";

import Amplify from "aws-amplify";
import aws_exports from "./aws-exports";
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";

Amplify.configure(aws_exports);
applyPolyfills().then(() => {
  defineCustomElements(window);
});

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import specific icons */
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* add icons to the library */
library.add(fas, far);

const app = createApp(App);
app.component("fa", FontAwesomeIcon);

const metaManager = createMetaManager();

/* v-html sanitize */
import sanitizeHTML from "sanitize-html";
app.config.globalProperties.$sanitize = sanitizeHTML;

app.use(store).use(router).use(metaManager).use(metaPlugin).mount("#app");
